<template>
  <div class="round-text">
    <svg viewBox="0 0 876 400" :width="`${circleSize * 1.275}px`">
      <path
        id="curve-text-1"
        d="M37.3979,372.9887C51.25,165.8806,223.6324,2.1783,434.25,2.1783S817.2505,165.8806,831.1021,372.9888"
        fill="none"
      />
      <text>
        <textPath class="round-text__left" xlink:href="#curve-text-1">
          {{ $t('roundtext.progress') }}
        </textPath>
        <textPath
          class="round-text__right"
          xlink:href="#curve-text-1"
          startOffset="84%"
        >
          {{ $t('roundtext.ingredients') }}
        </textPath>
      </text>
    </svg>
  </div>
</template>

<script>
export default {
  computed: {
    circleSize() {
      return this.$store.getters.circleSize;
    },
  },
};
</script>

<style lang="scss">
.round-text {
  svg {
    position: absolute;
    top: 0;
    left: calc(50% + 2px);
    transform: translate(-50%, -78px);

    text {
      font-size: 40px;
      text-transform: uppercase;
      color: $brownDark;
      fill: currentColor;
    }
  }
}

.round-text__right {
  text-align: right;
}

@media (max-width: 780px) {
  .round-text {
    display: none;
  }
}
</style>
